import types from './types';
import {
    fetchElementsPaginated
} from './common';


const apiUrl = '/api/invoices';


export function fetchInvoicesPaginated(page = 0, size = 10, fromDate) {
    const queryData = fromDate ? { from_date: fromDate } : undefined;
    return fetchElementsPaginated(`${apiUrl}/paginated`, page, size, types.ADMIN_LOAD_INVOICES, queryData);
}




// WEBPACK FOOTER //
// ./src/js/actions/invoices.js